// PIVOT — category tabs. Centered header, pill tabs (active = accent fill,
// inactive = accent-soft wash), one card-accordion pane per category. All
// panes are rendered; inactive ones carry the `hidden` attribute and the
// tabs runtime swaps them (.fq-tab[data-cat] / .fq-pane[data-cat]).
function itemHtml(ctx, it) {
    return `<div class="fq-acc">
  <button class="fq-qbtn" type="button" aria-expanded="false" aria-controls="p-${it.idx}">
    <span>${it.q}</span>
    ${ctx.showIcon ? ctx.icon : ''}
  </button>
  <div class="fq-panel" id="p-${it.idx}" role="region"><div><div class="fq-a">${it.aHtml}</div></div></div>
</div>`;
}
const pivot = {
    id: 'pivot',
    name: 'Pivot',
    tag: 'Category tabs',
    styleTag: 'Organized',
    description: 'Pill tabs split your FAQ into categories so nobody scrolls past twenty questions to find theirs. Cards expand in place under the active tab.',
    layout: 'tabs',
    defaultAccent: '#4a6cf7',
    darkDefault: false,
    catSupport: 'required',
    features: ['tabs', 'accordion'],
    render(ctx) {
        const tabs = ctx.cats
            .map((c, ci) => `<button class="fq-tab${ci === 0 ? ' fq-tab-on' : ''}" type="button" role="tab" aria-selected="${ci === 0 ? 'true' : 'false'}" data-cat="c${ci}">${c.name}</button>`)
            .join('\n');
        const panes = ctx.cats
            .map((c, ci) => `<div class="fq-pane" data-cat="c${ci}"${ci === 0 ? '' : ' hidden'}>
${c.items.map((it) => itemHtml(ctx, it)).join('\n')}
</div>`)
            .join('\n');
        const html = `<div class="fq-wrap">
  <div class="fq-head">
    <h2 class="fq-title">${ctx.title}</h2>
    ${ctx.subtitle ? `<p class="fq-sub">${ctx.subtitle}</p>` : ''}
  </div>
  <div class="fq-tabs" role="tablist">
${tabs}
  </div>
${panes}
</div>`;
        const css = `
.FQM .fq-wrap{max-width:720px;margin:0 auto}
.FQM .fq-head{text-align:center;margin-bottom:24px}
.FQM .fq-title{margin:0 0 8px;font-family:${ctx.v.head};font-size:34px;font-weight:650;line-height:1.12;letter-spacing:-0.015em;color:${ctx.v.ink}}
.FQM .fq-sub{margin:0;font-size:15.5px;line-height:1.6;color:${ctx.v.sub}}
.FQM .fq-tabs{display:flex;flex-wrap:wrap;justify-content:center;gap:8px;margin-bottom:22px}
.FQM .fq-tab{padding:9px 18px;border-radius:999px;background:${ctx.v.soft};color:${ctx.v.ink};font-size:13.5px;font-weight:600}
.FQM .fq-tab.fq-tab-on{background:${ctx.v.accent};color:#ffffff}
.FQM .fq-pane{display:flex;flex-direction:column;gap:10px}
.FQM .fq-acc{background:${ctx.v.card};border:1px solid ${ctx.v.border};border-radius:${ctx.v.radiusCard}}
.FQM .fq-qbtn{display:flex;width:100%;align-items:center;justify-content:space-between;gap:14px;padding:17px 20px;font-size:16px;font-weight:500;line-height:1.4;color:${ctx.v.ink}}
.FQM .fq-qbtn .fq-ic{font-size:12px;color:${ctx.v.accent}}
.FQM .fq-a{padding:0 20px 18px;font-size:15px;line-height:1.6;color:${ctx.v.sub}}
`;
        return { html, css };
    },
};
export default pivot;
